import api from '@/common/api.js'

export default {
  namespaced: true,

  state: {
    inventarios: null,
    itensInventario: null,
    itensInventarioTemp: null,
    totalItens: 0,
    item: null,
    pagination: {
      currentPage: 1,
      perPage: 10
    },
    totalPages: 0,
    dataItems: 0
  },

  getters: {
    getInventarios: (state) => state.inventarios,
    getItensInventario: (state) => state.itensInventario,
    getItensInventarioTemp: (state) => state.itensInventarioTemp,
    getTotalItens: (state) => state.totalItens,
    getItemSelecionado: (state) => state.item,
    getTotalPages: (state) => state.totalPages,
    getDataItems: (state) => state.dataItems,
  },

  actions: {

    async confirmarContagem({ commit }, { data }) {
      try {
        const response = await api.post('inventario/confirmarContagem', { ...data })

        return response
      } catch (error) {
        throw new Error(error)
      }

    },

    async getInventarios({ commit }) {
      try {
        const response = await api.get('inventario/getInventarios')

        commit('setInventarios', response.data)
      } catch (error) {
        throw new Error(error)
      }
    },

    async createNovoInventario({ commit }) {
      try {
        const response = await api.post('inventario/createNovoInventario')

        return response
      } catch (error) {
        throw new Error(error)
      }
    },

    async getItensInventario({ commit, state }, { data }) {
      const pagination = {
        per_page: state.pagination.perPage,
        page: state.pagination.currentPage
      }

      try {
        const params = {
          ...data,
          ...pagination
        }

        const response = await api.post('inventario/getItensInventario?page=' + pagination.page, { params: params })

        commit('totalItens', response.data.total)
        commit('setTotalPages', response.data.last_page)
        commit('setData', response.data)
        commit('setItensInventario', response.data.data)
      } catch (error) {
        throw new Error(error)
      }
    },

    async getItem({ commit, state }, { codItem }) {
      const arrayItens = state.itensInventario
      const item = arrayItens.find(objeto => objeto.ds_codigoitem === codItem);

      commit('setItemSelecionado', item)
    },

    async searchItemQrCode({ commit }, { data }) {
      try {
        const response = await api.post('inventario/searchItemQrCode', { ...data })

        console.log(response.data)
        commit('setItemSelecionado', response.data)
      } catch (error) {
        throw new Error(error)
      }
    },

    async filtrarItemPorPalavra({ commit, state }, { data }) {
      const pagination = {
        per_page: 40,
        page: 1
      }

      try {
        const params = {
          ...data,
          ...pagination
        }

        const response = await api.post('inventario/getItensInventario', { params: params })

        commit('totalItens', response.data.total)
        commit('setTotalPages', response.data.last_page)
        commit('setData', response.data)
        commit('setItensInventario', response.data.data)
      } catch (error) {
        throw new Error(error)
      }
    },

    async searchInventario({ commit, state }, { data }) {
      try {
        const idInventario = data
        const arrayInventarios = state.inventarios

        const inventario = arrayInventarios.find(objeto => objeto.nr_sequencial == idInventario)

        console.log(inventario)

        return inventario
      } catch (error) {
        throw new Error(error)
      }
    }

  },

  mutations: {
    setInventarios(state, inventarios) {
      state.inventarios = inventarios
    },
    setItensInventario(state, itensInventario) {
      state.itensInventario = itensInventario
      state.itensInventarioTemp = itensInventario
    },
    setItensInventarioTemp(state, itensInventario) {
      state.itensInventarioTemp = itensInventario
    },
    totalItens(state, totalItens) {
      state.totalItens = totalItens

    },
    setTotalPages(state, totalPages) {
      state.totalPages = totalPages

    },
    setItemSelecionado(state, item) {
      state.item = item
    },
    setCurrentPage(state, { page }) {
      state.pagination.currentPage = page
    },
    setData(state, data) {
      state.dataItems = data
    }
  }
}
